<template>
    <div class="SystemMainView">
        <div class="system-wrapper">
            <div class="exit-button" @click="$router.go(-1)">
                <svgicon class="exit-icon" icon="dashboard-icon" />
            </div>
            <img class="system-image" src="https://picsum.photos/id/237/200/300" />
            <h1 class="system-name">
                {{ system.name }}
            </h1>
            <p class="system-text">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odit minima perferendis dolorem voluptatem
                aliquid, exercitationem placeat quidem vero mollitia id eaque porro laudantium excepturi, est eveniet
                velit, alias illum vitae.
            </p>
            <div class="system-buttons-wrapper">
                <button @click="goToStepMemorizeView">Learn</button>
                <button>Practice</button>
            </div>
            <div class="system-library-and-instruction">
                <button>
                    <svgicon class="icon" icon="library2" />
                    Library
                </button>
                <button>
                    <svgicon class="icon" icon="article" />
                    Instructions
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            getSystemById: 'moduleCourse/getSystemById'
        }),

        system() {
            return this.getSystemById(this.$route.params.systemId);
        }
    },

    methods: {
        goToStepMemorizeView() {
            this.$router.push({
                name: 'StepMemorizeView'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.SystemMainView {
    background-image: url('~@/assets/images/background.png');
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    .exit-button {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 30px;
        cursor: pointer;
        .exit-icon {
            fill: white;
            width: 30px;
        }
    }

    .system-wrapper {
        padding: 40px 0;
        width: 30vw;
        height: 50vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .system-image {
            width: 10vw;
            height: 20vh;
        }
        h1 {
            font-size: 60px;
        }
        .system-text {
            font-size: 20px;
            text-align: center;
            padding: 10px 20px;
        }
        .system-buttons-wrapper {
            margin-top: 20px;
            button {
                width: 10vw;
                height: 50px;
                margin: 0 20px;
                cursor: pointer;
                border: none;
                border-radius: 8px;
                outline: none;
                font-size: 18px;
            }
        }
        .system-library-and-instruction {
            margin-top: 20px;
            display: flex;
            button {
                margin: 0 10px;
                background: inherit;
                border: none;
                outline: none;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 5px;
                color: white;
            }
        }
        .icon {
            fill: white;
            width: 50px;
            margin: 5px;
        }
    }
}
</style>
